import { render, staticRenderFns } from "./LoadingSection.vue?vue&type=template&id=dde55dc0&scoped=true"
import script from "./LoadingSection.vue?vue&type=script&lang=js"
export * from "./LoadingSection.vue?vue&type=script&lang=js"
import style0 from "./LoadingSection.vue?vue&type=style&index=0&id=dde55dc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde55dc0",
  null
  
)

export default component.exports